export const OBJECTS_LOAD = '@objects/load';
export const OBJECTS_OPEN = '@objects/open';
export const OBJECTS_CLOSE = '@objects/close';
